import React from 'react';
import Harper1 from '../../assets/work/Harper.png';
import { BsFillArrowRightCircleFill } from 'react-icons/bs';
import Harper2 from '../../assets/work/HarperAR.png';
import Harper3 from '../../assets/work/HarperANS.png';
import Harper4 from '../../assets/work/HarperAS.png';

const Harper = () => {
    return (
        <div className="bg-[#0a192f] mx-auto min-h-screen md:pt-44 pt-40">
      <h2 className="mb-12 flex justify-center md:text-5xl text-xl p-6 bg-stone-600 text-orange-500">
        Harper project details
      </h2>
      <div className="flex justify-center">
        <div className="text-5xl  md:max-w-4xl">
          <div className=" card card-compact max-w-full bg-base-100 shadow-xl mb-8">
            <figure>
              <img src={Harper1} alt="Harper Homepage" />
            </figure>
            <div className="card-body">
              <h2 className="card-title text-3xl text-orange-600 underline-offset-8 underline">
                Home Page
              </h2>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                This is the homepage for the Harper courier service.
              </p>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                Users can view certain services in the Our services section of the homepage or click View All Services to view all services.
              </p>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                Users can apply for a job as a delivery man and make money under the Deliver & Earn section as well.
              </p>
            </div>
          </div>
          <div className=" card card-compact max-w-full bg-base-100 shadow-xl mb-8">
            <figure>
              <img src={Harper2} alt="logistic help  page" />
            </figure>
            <div className="card-body">
              <h2 className="card-title text-3xl text-orange-600 underline-offset-8 underline">
                Service details Page
              </h2>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                This article contains information about the Harper courier specific service.
              </p>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                On this page, users can provide reviews for any services they use as well as read those of other users, but they must first log in first.
              </p>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                This page contains all the specific details regarding a given service. like information and the total cost for these services.
              </p>
            </div>
          </div>
          <div className=" card card-compact max-w-full bg-base-100 shadow-xl mb-8">
            <figure>
              <img src={Harper3} alt="add service" />
            </figure>
            <div className="card-body">
              <h2 className="card-title text-3xl text-orange-600 underline-offset-8 underline">
                Add Service
              </h2>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                This is the Firship Code Camp website's Add service page.
              </p>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                Admin can add any service with name, image, pricing, and description to this page.
              </p>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                solely for administrators. User is unable to access this.
              </p>
            </div>
          </div>
          <div className=" card card-compact max-w-full bg-base-100 shadow-xl mb-8">
            <figure>
              <img src={Harper4} alt="Admin page" />
            </figure>
            <div className="card-body">
              <h2 className="card-title text-3xl text-orange-600 underline-offset-8 underline">
                All Service page
              </h2>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                The Harper Courier All Services Page is located here.
              </p>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                Here are all of Harper Courier's services in detail.
              </p>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                The view details button must be clicked in order to view details, and only then can the user see the full details.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    );
};

export default Harper;